<mat-toolbar color="primary">
  <span (click)="goToDefaultPath()" style="cursor: pointer;">Website title</span>
  <span style="flex: 1 1 auto;"></span>
  <button mat-icon-button *ngIf="isLoggedIn" (click)="setCurrentPathDefault()">
    <mat-icon *ngIf="currentPathIsDefault; else notDefault">bookmark</mat-icon>
    <ng-template #notDefault><mat-icon>bookmark_outline</mat-icon></ng-template>
  </button>
  <novus-user-menu></novus-user-menu>
</mat-toolbar>
